import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";

import { SrOnly } from "@/components/Layout/Parts";
import { ResponsiveTable, Table, TableContent, Th } from "@/components/Table";
import { api } from "@/utils/api";
import { ImageToolStyleDescriptionResource } from "@/types/resources";
import ImageToolSettingsTableRow from "./ImageToolSettingsTableRow";

const StyledTable = styled(Table)`
  th,
  td {
    padding: 16px 12px;
    font-size: 11px;
    font-weight: 700;
    &:first-child {
      width: calc(46% - 56px);
      padding-left: 24px;
    }
    &:nth-child(2) {
      width: 54%;
    }

    &:last-child {
      width: 56px;
      position: relative;
    }
  }
  td {
    padding: 20px 12px;
  }
`;

export const ImageToolSettingsTable = () => {
  const {
    data: descriptions,
    isError,
    isLoading,
  } = useQuery<ImageToolStyleDescriptionResource[]>(
    ["image_generation_descriptions"],
    () =>
      api.get<never, ImageToolStyleDescriptionResource[]>(
        "/v1/image-generation-descriptions"
      ),
    {
      staleTime: 1000 * 120,
    }
  );
  return (
    <ResponsiveTable>
      <StyledTable>
        <thead>
          <tr>
            <Th>Title</Th>
            <Th>Description</Th>
            <Th>
              <SrOnly>Actions</SrOnly>
            </Th>
          </tr>
        </thead>
        <tbody>
          <TableContent
            isLoading={isLoading}
            isError={isError}
            hasData={!!descriptions?.length}
          >
            {descriptions?.map((description) => (
              <ImageToolSettingsTableRow
                key={description.id}
                description={description}
              />
            ))}
          </TableContent>
        </tbody>
      </StyledTable>
    </ResponsiveTable>
  );
};
